import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

export const agencyRegistrationValidationSchema = () =>
  createValidationSchema({
    agencyId: commonValidationSchemas.string({ nullable: true }),
  });
